<template>
  <div class="changeStatus">
    <section>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-suffix=":"
        style="padding-bottom: 50px"
        class="demo-ruleForm"
      >
        <li class="redText">注意：※为必填项</li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 房主姓名：
          </div>
          <el-form-item class="input_right" prop="name">
            <el-input
              placeholder="请输入房主姓名"
              v-model="form.name"
              type="text"
            />
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 产权证号：
          </div>
          <el-form-item class="input_right" prop="cqzh">
            <el-input
              placeholder="请输入产权证号"
              v-model="form.cqzh"
              type="text"
            />
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 用户类型：
          </div>
          <el-form-item class="input_right" prop="yhlx">
            <dict-select dict-code="用户类型" v-model="form.yhlx" />
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 小区名称：
          </div>
          <el-form-item class="input_right" prop="three">
            <el-autocomplete v-model="form.three" @change="inputVal" @blur="handleBlur" placeholder="请输入小区名称" clearable :fetch-suggestions="directSearch" @select="threeDirect" style="width: 100%">
              <template slot-scope="{ item }">
                <div class="">{{ item.three }}</div>
                <span class="adress_search">{{ item.one+'/'+item.two }}</span>
              </template>
            </el-autocomplete>
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 楼号：
          </div>
          <el-form-item class="input_right" prop="addressPrefix">
            <dict-select dict-code="lh" is-constants v-model="form.addressPrefix" />
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 单元号：
          </div>
          <el-form-item class="input_right" prop="unit">
            <dict-select dict-code="dy" is-constants v-model="form.unit" />
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 层数：
          </div>
          <el-form-item class="input_right" prop="floor">
            <dict-select dict-code="lc" is-constants v-model="form.floor" />
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 房间号：
          </div>
          <el-form-item class="input_right" prop="room">
            <el-input-number placeholder="请输入房间号" :controls="false" type="text" v-model="form.room"></el-input-number>
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 面积(m²)：
          </div>
          <el-form-item class="input_right" prop="jzmj">
            <el-input-number
              placeholder="请输入供热面积"
              v-model="form.jzmj"
              :controls="false"
              type="text"
            />
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 房屋地址：
          </div>
          <el-form-item class="input_right" prop="address">
            <el-input
              placeholder="请输入房屋地址"
              v-model="form.address"
              type="text"
            />
          </el-form-item>
        </li>
        <li class="li_flex">
          <div class="lable_left">
            <span class="redText">※</span> 证件类型：
          </div>
          <div class="input_right">身份证</div>
        </li>

        <li class="flex_input">
          <div class="lable_left">
            <span class="redText">※</span> 证件号码：
          </div>
          <el-form-item class="input_right" prop="idNumber">
            <el-input
              placeholder="请输入证件号码"
              v-model="form.idNumber"
              type="text"
            />
          </el-form-item>
        </li>
        <li class="flex_input">
          <div class="lable_left"><span class="redText">※</span> 手机号：</div>
          <el-form-item class="input_right" prop="mobNo">
            <el-input
              placeholder="请输入联系电话"
              v-model.trim="form.mobNo"
              type="text"
            />
          </el-form-item>
        </li>
        <li class="flex_input" v-if="captchaValidate">
          <div class="lable_left"><span class="redText">※</span> 验证码：</div>
          <el-form-item class="input_right" prop="captcha">
            <el-input
              placeholder="验证码"
              style="width: 60%"
              v-model.trim="form.captcha"
              type="text"
            />
            <button
              :disabled="disabled"
              type="button"
              @click.stop="getYzm"
              class="yzmBtn"
              style="width: 38%"
            >
              {{ msg }}
            </button>
          </el-form-item>
        </li>
        <li>
          <span class="redText" style="margin-right: 5px">※ </span>
          身份证上传：<span class="buleText" @click="sfzFlag = !sfzFlag"
            >查看样例</span
          >
        </li>
        <div class="file" v-if="imageId">
          <input
            type="file"
            accept="image/*"
            name="uploader-input"
            class="uploader-file"
            @change="getId"
          />身份证正面
        </div>
        <div class="file" v-if="imageIdBack">
          <input
            type="file"
            accept="image/*"
            name="uploader-input"
            class="uploader-file"
            @change="getIdBack"
          />身份证背面
        </div>
        <div v-for="(item, ind) in imgIdList" :key="ind+100" class="imgDiv">
          <b @click="deleteImgId(ind)" class="el-icon-error error_icon"></b>
          <img class="imgItemRead avatar" :src="item" alt="" />
        </div>
        <div v-for="(item, ind) in imgIdBackList" :key="ind+10" class="imgDiv">
          <b @click="deleteImgIdBack(ind)" class="el-icon-error error_icon"></b>
          <img class="imgItemRead avatar" :src="item" alt="" />
        </div>
        <li>
          <span class="redText" style="margin-right: 5px">※ </span
          >房产证或购房合同：<span class="buleText" @click="xyFlag = !xyFlag"
        >查看样例</span
        >
        </li>
        <li>
          <span class="redText" style="font-size: 10px"
            >注意：仅需上传户主信息、房屋信息及签章页</span
          >
        </li>
        <div class="file">
          <input
            multiple="multiple"
            type="file"
            accept="image/*"
            name="uploader-input"
            class="uploader-file"
            @change="getIdHt"
          />房产证或购房合同
        </div>
        <div v-for="(item, ind) in imgHtList" :key="ind+1000" class="imgDiv">
          <b @click="deleteHtId(ind)" style="z-index: 0" class="el-icon-error error_icon"></b>
          <img class="imgItemRead avatar" :src="item" alt="" />
        </div>
      </el-form>
    </section>
    <el-checkbox-group style="margin-bottom: 5px;" v-model="checkedCities">
      <el-checkbox label="1" >
        <p style="font-size: 12px">
          <span style="font-size: 12px">本人已阅读并同意</span> <span class="buleText" @click="getXy">《申请入网协议》</span>勾选后协议生效。
        </p>
      </el-checkbox>
    </el-checkbox-group>

    <button
      type="button"
      class="btn_bx"
      @click.stop="changeStatus"
    >
      提交申请
    </button>
    <mt-popup
      v-model="sfzFlag"
      class="xy"
      @click="sfzFlag=!sfzFlag"
      popup-transition="popup-fade"
    >
      <img class="sfzsl" style="width: 100%;z-index: 9999" @click="sfzFlag=!sfzFlag" src="../../../../static/image/sfzsl.jpg" alt="">
    </mt-popup>

    <mt-popup
      v-model="xyFlag"
      class="xy"
      @click="xyFlag=!xyFlag"
      popup-transition="popup-fade"
    >
      <img :src="item.img"  @click.stop="xyFlag=!xyFlag" style="width: 100%;z-index: 9999" v-for="item in tgimg" alt="">

    </mt-popup>

  </div>
</template>

<script>
  import {
    findRwshXq,
    getBindReli,
    getCaptcha,
    getOpenId,
    getUserYhkh,
    rwshSave,
  } from "@/api";
  import {dataURLtoFilename, getQueryVariable, isCnNewID, validatePhone} from "@/utils";
export default {
  data() {
    return {
      thirdId: sessionStorage.getItem("thirdId"),
      companyCode: sessionStorage.getItem("companyCode"),
      value: [],
      options: [],
      form: {},
      tgimg: [
        {
          img: require('../../../../static/image/合同1.jpg')
        },
      ],
      rules: {
        mobNo: [
          {
            required: true,
            message: "必填",
          },
          { validator: validatePhone, trigger: 'blur' }
        ],
        idNumber: [
          {
            required: true,
            message: "必填",
          },
          {
            validator: isCnNewID,trigger: "blur"
          },
        ],
        name: [
          {
            required: true,
            message: "必填",
          },
        ],
        jzmj: [
          {
            required: true,
            message: "必填",
          },
        ],
        three: [
          {
            required: true,
            message: "必填",
          },
        ],
        address: [
          {
            required: true,
            message: "必填",
          },
        ],
        captcha: [
          {
            required: true,
            message: "必填",
          },
        ],
        room: [
          {
            required: true,
            message: "必填",
          },
        ],
        floor: [
          {
            required: true,
            message: "必填",
          },
        ],
        addressPrefix: [
          {
            required: true,
            message: "必填",
          },
        ],
        unit: [
          {
            required: true,
            message: "必填",
          },
        ],
        yhlx: [
          {
            required: true,
            message: "必填",
          },
        ],
        cqzh: [
          {
            required: true,
            message: "必填",
          },
        ],
      },
      fileList: [],
      imgList: [],
      imgIdList: [],
      imgIdBackList: [],
      imageIdHt: true,
      imgHtList: [],
      imageId: true,
      imageIdBack: true,
      imagefcz: true,
      sfzFlag: false,
      imgHref: "",
      maxtime: 60, //一个小时，按秒计算，自己调整!
      timer: null,
      msg: "获取验证码",
      disabled: false,
      captchaValidate: false,
      loading: false,
      xq: '',
      xyFlag: false,
      checkedCities: [],
    };
  },
  mounted() {
    if (!this.companyCode || !this.thirdId) {
      var companyCode = getQueryVariable("state");
      var code = getQueryVariable("code");
      if (companyCode.indexOf("#") > -1) {
        companyCode = companyCode.split("#")[0];
      }
      sessionStorage.setItem("state", companyCode);
      if (companyCode != "huilian") {
        this.type = 0;
      }
      sessionStorage.setItem("companyCode", companyCode);
      sessionStorage.setItem("type", this.type);
      getOpenId({
        state: companyCode,
        code: code,
      }).then((res) => {
        var openId = res.data.openId;
        sessionStorage.setItem("thirdId", openId);
        sessionStorage.setItem("unionId", res.data.unionid||'');
        this.getUseYhkhFlag()
        this.getBindReli();
      });
    } else {
      this.getBindReli();
      this.getUseYhkhFlag()
    }
    this.captchaValidate =
      JSON.parse(sessionStorage.getItem("roles")) &&
      JSON.parse(sessionStorage.getItem("roles")).captchaValidate;

  },
  methods: {
    handleBlur(data) {
      if(!this.form.one) {
        this.form.three = ''
      }
    },
    inputVal() {
      this.form.one = ''
    },
    getXy() {
      this.xyFlag = true
    },
    directSearch(item,cb) {
      if(item) {
        this.loading = true
        let three = item.trim()
        findRwshXq({three: three}).then(res => {
          res.data.map(v=>{
            v.value = v.three
          })
          cb(res.data);
        }).finally(()=>{
          this.loading = false
        })
      } else {
        cb([]);
      }
    },
    threeDirect(item) {
      this.form.one = item.one
      this.form.two = item.two
    },
    getUseYhkhFlag() {
      getUserYhkh({companyCode:sessionStorage.getItem("companyCode")}).then(res=>{
        sessionStorage.setItem('useYhkh',res.data.useYhkh)
        this.useYhkh = res.data.useYhkh
      })
    },
    getBindReli() {
      if (sessionStorage.getItem("state") == "huilian") {
        getBindReli(sessionStorage.getItem("thirdId")).then((res) => {
          if (!res.data) {
            this.$router.push("/bindComponey");
          } else {
            sessionStorage.setItem("companyCode", res.data.companyCode);
            this.name = res.data.companyName;
            this.city = res.data.city
          }
        })
      }
    },
    getId(e) {
      let file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        //成功读取文件
        this.imgIdList.push(e.target.result);
      };
      this.imageId = false;
    },
    getIdBack(e) {
      let file = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        //成功读取文件
        this.imgIdBackList.push(e.target.result);
      };
      this.imageIdBack = false;
    },
    getIdHt(e) {
      let fileList = e.target.files;
      for (var i = 0; i < fileList.length; i++) {
        let file = fileList[i]; /* 获取单个File对象 */
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          //成功读取文件
          this.imgHtList.push(e.target.result);
        };
      }
      this.imageIdHt = false;
    },
    deleteHtId(ind) {
      this.imgHtList.splice(ind, 1);
      this.imageIdHt = true;
    },
    deleteImgId(ind) {
      this.imgIdList.splice(ind, 1);
      this.imageId = true;
    },
    deleteImgIdBack(ind) {
      this.imgIdBackList.splice(ind, 1);
      this.imageIdBack = true;
    },
    getYzm() {
      var reg_tel = /^(1)\d{10}$/;
      if (!reg_tel.test(this.form.mobNo)) {
        this.$toast("请输入正确的手机号码");
        return;
      }
      let params = {
        sysType: 0,
        phone: this.form.mobNo,
      };
      getCaptcha(params).then((res) => {
        if (res.code == "0000") {
          this.maxtime = 60;
          this.disabled = true;
          this.timer = setInterval(() => {
            this.CountDown();
          }, 1000);
        }
      });
    },
    CountDown() {
      if (this.maxtime > 0) {
        let seconds = this.maxtime;
        this.msg = +seconds + "s" + "后获取";
        --this.maxtime;
      } else {
        clearInterval(this.timer);
        this.msg = "获取验证码";
        this.disabled = false;
      }
    },
    changeStatus() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.imageId) {
            this.$toast("请上传身份证正面照片");
            return false;
          }
          if (this.imageIdBack) {
            this.$toast("请上传身份证背面照片");
            return false;
          }
          if (this.imgHtList.length == 0) {
            this.$toast("请上传房产证或购房合同");
            return false;
          }
          if(!this.checkedCities.length) {
            this.$toast("请阅读协议再提交");
            return false;
          }
          var formdata = new FormData();
          for (let k in this.form) {
            formdata.append(k, this.form[k]);
          }
          this.imgIdList.map((item) => {
            console.log(dataURLtoFilename(item,'身份证正面'))
            formdata.append("files", dataURLtoFilename(item,'身份证正面'));
          });
          this.imgIdBackList.map((item) => {
            console.log(dataURLtoFilename(item,'身份证背面'))
            formdata.append("files", dataURLtoFilename(item,'身份证背面'));
          });
          this.imgHtList.map((item,ind) => {
            console.log(dataURLtoFilename(item,'合同'+(ind+1)))
            formdata.append("files", dataURLtoFilename(item,'合同'+(ind+1)));
          });
          rwshSave(formdata).then((res) => {
            if (res.code == "0000") {
              this.$toast("操作成功");
              this.$router.push({
                path: '/rwList',
                query: {
                  mobNo: this.form.mobNo
                }
              })
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.changeStatus {
  padding: 3%;
  min-height: 90%;
  background: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 90%;
  .error_icon{
    z-index: auto!important;
  }
}
.yzmBtn {
  border: 1px solid #c2e7b0;
  border-radius: 3px;
  line-height: 26px;
  background: #f0f9eb;
  color: #67c23a;
  font-size: 12px;
  /*background: #000;*/
}
.xy {
  background: #fff;
  /*height: 80vh;*/
  width: 90%;
  border-radius: 5px;
  overflow-y: auto;
  /*margin-left: 5%;*/
  padding: 5px;
}
.xyPng {
  width: 100%;
}
.changeStatus .mint-cell-wrapper {
  font-size: 14px !important;
}

.changeStatus .buleText {
  color: #1e88c7;
  font-size: 12px;
}

.changeStatus .mask {
  position: fixed;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
}

.changeStatus .btn_bx {
  width: 100%;
  /*margin-top: 3rem;*/
  font-size: 1rem;
  height: 2.5rem;
  background: #47c34d;
  border-radius: 3px;
}

header,
footer {
  height: 60px;
  line-height: 60px;
}

header {
  margin-bottom: 5px;
  background-color: #fff;
}

section {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 100%;
  overflow: auto; /* winphone8和android4+ */
  -webkit-overflow-scrolling: touch; /* ios5+ */
}

/*.sfzsl {*/
/*  width: 90%;*/
/*  height: 80vh;*/
/*  left: 5%;*/
/*  border-radius: 10px;*/
/*  position: absolute;*/
/*}*/

.redText {
  color: red;
}

.lable_left {
  width: 105px;
  color: black;
}

.flex_input {
  display: flex;
  line-height: 40px;
}

.changeStatus li {
  line-height: 40px;
  display: flex;
  border-bottom: 1px solid #f7f6f7;
}

.li_flex {
  justify-content: space-between;
}

.lable_right {
  color: #949393;
}

.greyText {
  color: #8c939d;
  margin-right: 10px;
}

.changeStatus .input_right {
  flex: 1;
  color: black;
}

.el-input__inner {
  padding: 0 !important;
}

.changeStatus .input_right input,
.input_right textarea {
  border: none;
  outline: none;
  float: 1;
  margin-top: 5px;
}

.changeStatus .el-form-item {
  margin-bottom: 0 !important;
}

.itemList {
  /* border-bottom: 1px solid #fcfcfc; */
  color: #646262;
  /* padding-left: 8%; */
}

/*.mint-cell-wrapper {*/
/*  padding: 0 !important;*/
/*}*/
.item {
  /* border-bottom: 1px solid #f1f1f1;
    padding-bottom: 20px; */
}

.uploader-file {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.uploader-file:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100%;
  height: 178px;
  display: block;
  margin-top: 25px;
}

.file {
  width: 90%;
  height: 30px;
  position: relative;
  display: inline-block;
  background: #fbfdff;
  border: 1px #c0ccda dashed;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #1e88c7;
  text-decoration: none;
  text-indent: 0;
  text-align: center;
  line-height: 30px;
}

.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}

.file:hover {
  background: #fbfdff;
  border-color: #aadffd;
  color: #004974;
  text-decoration: none;
}

.imgDiv {
  position: relative;
}

.error_icon {
  position: absolute;
  font-size: 25px;
  right: 0px;
  top: 0px;
  z-index: 999999;
  color: #f00;
}
.el-input-number.is-without-controls .el-input__inner {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/view/ywbl/rwsq/index.vue